<template>
  <div>
    <PageHeader :schema="$schemas.accountingAccount" />
    <PageContent>
      <DynamicFormPage
        :schema="$schemas.accountingAccount"
        :service="$api.accountingAccounts"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateAccountingAccount',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
